import Link from "./MoodLink";

const Button = (props) => {
  const { children, className, to, variant = "primary" } = props;

  const getClass = () => {
    switch (variant) {
      case 'primary':
        return "bg-green-400 hover:bg-green-300 active:opacity-80 text-tan-100"
      case 'secondary':
        return "bg-tan-100 border-2 border-green-400 hover:bg-green-400 active:opacity-80 text-green-400 hover:text-tan-100 active:opacity-80"
      case 'ghost':
        return "bg-transparent border-2 border-green-400 hover:bg-green-400 active:opacity-80 text-green-400 hover:text-tan-100 active:opacity-80"
      default:
        break;
    }
  }

  const getStroke = () => {
    switch (variant) {
      case 'primary':
        return "duration-300 stroke-tan-100"
      case 'secondary':
        return "duration-300 stroke-green-400 group-hover:stroke-tan-100 group active:opacity-80"
      case 'ghost':
        return "duration-300 stroke-green-400 group-hover:stroke-tan-100 group active:opacity-80"
      default:
        break;
    }
  }

  return (
    <Link to={to} className={`${className} ${getClass()} group duration-300 w-full py-3 px-5 leading-5 -tracking-[0.32px] rounded-full flex justify-center items-center gap-1`} target="_blank">
      <div className='text-base font-bold'>{children}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_185_1045)">
          <path d="M2.5 8H13.5" className={getStroke()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 3.5L13.5 8L9 12.5" className={getStroke()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_185_1045">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Link>
  )
};

export default Button;